import { Toaster } from "react-hot-toast";

/*
 * Popup messages in FXRY's palette (brand board, 2026): Ivory card, Mint for
 * good news, Golden for something to fix, Dark Ivory for a heads-up. Yellow is
 * accent-only, and there is no red. Mockup approved by Calley 2026-09-13.
 *
 * The same file lives in fxryshop and fxrypopup — change both.
 */
const COLORS = {
  ivory: "#F4F3EE",
  darkIvory: "#D5D1C6",
  black: "#212322",
  charcoal: "#373C3B",
  golden: "#B88122",
  mint: "#B5D1AA",
};

const Mark = ({ background, color = COLORS.black, children }) => (
  <span
    aria-hidden="true"
    style={{
      width: 26,
      height: 26,
      borderRadius: "50%",
      background,
      color,
      display: "grid",
      placeItems: "center",
      flex: "none",
      fontWeight: 700,
      fontSize: 14,
      lineHeight: 1,
    }}
  >
    {children}
  </span>
);

const Sparkle = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" style={{ display: "block" }}>
    <path
      fill={COLORS.charcoal}
      d="M12 1.5c.6 5.6 4.9 9.9 10.5 10.5-5.6.6-9.9 4.9-10.5 10.5C11.4 16.9 7.1 12.6 1.5 12 7.1 11.4 11.4 7.1 12 1.5Z"
    />
  </svg>
);

/** A bold first line with an optional plain second line:
 *  toast.error(<ToastText title="…" detail="…" />) */
export const ToastText = ({ title, detail }) => (
  <span style={{ display: "block", textAlign: "left" }}>
    <strong style={{ display: "block", fontWeight: 600 }}>{title}</strong>
    {detail && <span style={{ color: COLORS.charcoal }}>{detail}</span>}
  </span>
);

const baseStyle = {
  background: COLORS.ivory,
  color: COLORS.black,
  border: `1px solid ${COLORS.darkIvory}`,
  borderRadius: 12,
  padding: "12px 16px 12px 12px",
  boxShadow: "0 6px 18px rgba(55, 60, 59, 0.12)",
  fontFamily: '"halyard-text", sans-serif',
  fontSize: 14,
  lineHeight: 1.4,
  maxWidth: 360,
  alignItems: "flex-start",
};

const FxryToaster = () => (
  <Toaster
    toastOptions={{
      style: baseStyle,
      success: {
        style: { ...baseStyle, borderColor: COLORS.mint },
        icon: (
          <Mark background={COLORS.mint}>
            <Sparkle />
          </Mark>
        ),
      },
      error: {
        style: {
          ...baseStyle,
          borderColor: COLORS.golden,
          background: "#FAF5EA",
        },
        icon: <Mark background={COLORS.golden}>!</Mark>,
      },
      blank: {
        icon: (
          <Mark background={COLORS.darkIvory} color={COLORS.charcoal}>
            <span style={{ fontFamily: "Georgia, serif", fontStyle: "italic" }}>
              i
            </span>
          </Mark>
        ),
      },
    }}
  />
);

export default FxryToaster;
